import styled from "styled-components";
import React from "react";

export const ProductCardWrapper = styled(React.Fragment)`
  .p-button {
    background-color: #e7eef9;
  }
`;

const TravelInsuranceWrapper = styled.div`
  input:focus,
  input:hover {
    border: 1px solid #6b47f5 !important;
    box-shadow: none !important;
  }
  .p-button:hover {
    background-color: #6b47f5;
    border-color: #6b47f5;
  }
  .field {
    margin-bottom: 1.5rem;
  }
  .submit-btn {
    background-color: #6b47f5;
    border-color: #6b47f5;
    padding: 10px 30px;
    box-shadow: none;
  }
  .submit-btn-stc {
    background-color: #4f008c;
    border-color: #4f008c;
    padding: 10px 30px;
    box-shadow: none;
    :hover {
      background-color: #4f008c;
      border-color: #4f008c;
    }
  }

  .custom-calendar-input {
    input {
      border-right: none;
    }
    .p-button-icon-only {
      padding: 0;
      background: transparent;
      color: #4f008c;
      border-left: none;
      border-radius: 0;
      border-color: #ced4da;
      :focus {
        box-shadow: none;
      }
    }
    .custom-calendar-input-stc {
      input,
      .p-dropdown {
        width: 100%;
        height: 40px;
        border-radius: 0;
        color: #4f008c;
        font-weight: bold;
      }

      .p-inputtext {
        color: #4f008c;
        font-weight: bold;
      }
    }

    &.p-invalid {
      .p-button-icon-only {
        border-color: red;
        color: red;
      }
    }
  }

  .travel_wc_payment {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 1rem;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;

    .travel_wc_payment_price {
      display: flex;
      align-items: center;

      .travel_wc_payment_price_text {
        color: #679ab4;
        padding: 0 10px;
      }
      .travel_wc_payment_price_sar {
        color: #818b9b;
        padding: 0 5px;
      }
      .travel_wc_payment_price_amt {
        color: #6b47f5;
      }

      .p-progress-spinner {
        width: 20px;
        height: 20px;
      }
    }
  }

  .container {
    .text_color_wc {
      color: #ffffff;
    }
  }
  .worldcup_img_bg {
    padding-bottom: 3.6rem;
  }
  .ar {
    .custom-calendar-input .p-button-icon-only {
      border-left: 1px solid #ced4da;
      border-right: none;
      border-radius: 0;
      // border-color: #ced4da;
    }
    .custom-calendar-input input {
      border-right: 1px solid #ced4da;
      border-left: none;
    }
    .prefix {
      border: 1px solid #ced4da;
      border-right: none;
    }
    .submit-btn {
      float: left;
    }
    .submit-btn-stc {
      float: left;
    }
  }

  @media only screen and (max-width: 576px) {
    .ar {
      * {
        font-size: small;
      }
    }
  }

  @media only screen and (min-width: 1000px) {
    .product-item {
      width: 20%;
    }
  }
`;

export default TravelInsuranceWrapper;
